import ChevronRight from '@assets/images/chevron-right.svg?react'
import ExternalLinkIcon from '@assets/images/external-link-icon.svg?react'
import { Link } from 'react-router-dom'
import './linkButton.scss'
import Typography from '@/ui/components/typography'
import { TFontVariant } from '@/core/theme'

type Props = {
    to?: string
    text?: string
    external?: boolean
    withChevron?: boolean
    onClick?: () => void
    icon?: TChild
    color?: string
    className?: string
    variant?: TFontVariant
}

const LinkButton = ({
    to,
    text,
    external = false,
    withChevron = true,
    onClick,
    color,
    className,
    variant,
}: Props) => {
    if (external) {
        return (
            <a
                className={`link-button ${className}`}
                href={to}
                target="_blank"
                rel="noreferrer"
                style={{ color }}
            >
                <Typography variant={variant} color={color}>
                    {text}
                </Typography>{' '}
                {withChevron && (
                    <ExternalLinkIcon data-testid="external-link-icon" />
                )}
            </a>
        )
    }

    if (!to) {
        return (
            <span
                className="link-button"
                onClick={onClick}
                data-testid={text}
                style={{ color }}
            >
                <Typography variant={variant} color={color}>
                    {text}
                </Typography>{' '}
                {withChevron && <ChevronRight data-testid="chevron-icon" />}
            </span>
        )
    }

    return (
        <Link
            className="link-button"
            to={{ pathname: to }}
            onClick={onClick}
            data-testid={`link-to-${to}`}
            style={{ color }}
        >
            <Typography variant={variant} color={color}>
                {text}
            </Typography>{' '}
            {withChevron && <ChevronRight data-testid="chevron-icon" />}
        </Link>
    )
}

export default LinkButton
